import styled from "@emotion/styled";
import { FC, useCallback, useMemo } from "react";
import { windowModule } from "@/modules/window";
import { MDSButton, MDSIcon, MDSIconKind } from "@/mds";

interface FloatingTextMessageMediaButtonProps {
  contentType: string;
  publicUrl: string;
}

export const FloatingTextMessageMediaButton: FC<FloatingTextMessageMediaButtonProps> = ({
  contentType,
  publicUrl,
}) => {
  const buttonInfo: {
    iconKind: MDSIconKind;
    label: string;
  } = useMemo(() => {
    if (contentType.startsWith("image/")) {
      return {
        iconKind: MDSIconKind.Image,
        label: "Image",
      };
    }

    if (contentType.startsWith("video/")) {
      return {
        iconKind: MDSIconKind.Video,
        label: "Video",
      };
    }

    if (contentType.startsWith("audio/")) {
      return {
        iconKind: MDSIconKind.WaveformLines,
        label: "Audio",
      };
    }

    if (contentType.startsWith("application/pdf")) {
      return {
        iconKind: MDSIconKind.Pdf,
        label: "PDF",
      };
    }

    return {
      iconKind: MDSIconKind.File,
      label: "File",
    };
  }, [contentType]);

  const onClick = useCallback(() => {
    windowModule.openInNewTab({ url: new URL(publicUrl) });
  }, [publicUrl]);

  return (
    <TextMessageMediaButton onClick={onClick}>
      <TextMessageMediaButtonIcon kind={buttonInfo.iconKind as MDSIconKind} />
      {buttonInfo.label}
    </TextMessageMediaButton>
  );
};

export const TextMessageMediaButton = styled(MDSButton)(
  () => `
  text-align: left;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  width: fit-content;
`
);

const TextMessageMediaButtonIcon = styled(MDSIcon)`
  margin-right: ${({ theme }) => theme.spacing["1"]};
`;
